export default __webpack_public_path__ + "static/media/364.b8052f9a.png";